<template>
  <VDialog
    :value="isOpen"
    width="500"
    @input="val => $emit('dialogToggle', val)"
  >
    <VCard>
      <VCardTitle
        class="headline grey lighten-2"
        primary-title
      >
        {{ confirmHeaderText }}
      </VCardTitle>

      <VCardText>
        {{ confirmBodyText }}
      </VCardText>

      <VDivider />

      <VCardActions>
        <VSpacer />

        <VBtn
          color="primary"
          flat
          @click="$emit('dialogToggle', false)"
        >
          {{ cancelButtonTranslatedText }}
        </VBtn>

        <VBtn
          :color="confirmButtonColor"
          :loading="isLoading"
          :disabled="isLoading"
          @click="$emit('confirm')"
        >
          {{ confirmButtonTranslatedText }}
        </VBtn>
      </VCardActions>
    </VCard>
  </VDialog>
</template>

<script>
export default {
  name: 'ConfirmModal',
  props: {
    isOpen: Boolean,
    isLoading: Boolean,
    confirmHeaderText: String,
    confirmBodyText: String,
    confirmButtonColor: {
      type: String,
      default: 'red'
    },
    confirmButtonText: {
      type: String,
      default: null
    },
    cancelButtonText: {
      type: String,
      default: null
    }
  },
  computed: {
    confirmButtonTranslatedText () {
      if (this.confirmButtonText) {
        return this.confirmButtonText
      } else {
        return this.$nt('ok')
      }
    },
    cancelButtonTranslatedText () {
      if (this.cancelButtonText) {
        return this.cancelButtonText
      } else {
        return this.$nt('cancel')
      }
    }
  }
}
</script>

<style scoped>

</style>
